// Dátum bez času (DATE stĺpec) príde zo servera ako polnoc slovenského času
// prepočítaná na UTC: 30. 9. → "2026-09-29T22:00:00.000Z". Odrezanie prvých
// 10 znakov preto dá o deň MENEJ — editor faktúr tak pri každom otvorení
// uloženej faktúry posunul vystavenie, dodanie aj splatnosť o deň dozadu
// (nahlásené 2026-10-01: 30. 9. sa zmenilo na 29. 9.).
// ymdLocal vráti deň v miestnom čase; čistý "YYYY-MM-DD" nechá bez zmeny.
export function ymdLocal(v: string | Date | null | undefined): string {
  if (!v) return '';
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
